import { render, staticRenderFns } from "./BaseInputRequired.vue?vue&type=template&id=54479cfe&scoped=true&"
import script from "./BaseInputRequired.vue?vue&type=script&lang=js&"
export * from "./BaseInputRequired.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputRequired.vue?vue&type=style&index=0&id=54479cfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54479cfe",
  null
  
)

export default component.exports